import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../sidebar';
import TopNavBar from '../topNavBar';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';

const InnerLayout = ({ children, module, is_new = false, navigationPath = null }) => {
    const [currentPage, setCurrentPage] = useState(module);
    const [isOpen, setIsOpen] = useState(false);
    // const storeData = (localStorage.getItem('storeData'));
    // const accountData = JSON.parse(storeData);
    const accountData = useSelector((store) => store?.userReducer?.data);
    const [isExpired, setIsExpired] = useState(accountData ? dayjs(accountData.offerEndDate).isBefore(dayjs(), 'day') : false);
    const navigate = useNavigate();

    const handleSelectPage = (page) => {
        setCurrentPage(page);
    };

    return (
        <div className="flex w-full h-screen">
            <Sidebar currentPage={currentPage} onSelectPage={handleSelectPage} isOpen={isOpen} setIsOpen={setIsOpen} />

            <div
                className={`transition-all duration-300 flex-1 overflow-y-auto bg-gray-100 ${isOpen ? "md:ml-60" : "md:ml-16"} ml-16 relative`}
            >
                <TopNavBar currentPage={currentPage} is_new={is_new} navigationPath={navigationPath} />

                <div className="flex-1 overflow-y-auto bg-gray-100" style={{ height: "93vh" }}>
                    {children}
                </div>

                {isExpired && currentPage !== "Subscription" && (
                    <div className="absolute inset-0 flex items-center justify-center bg-gray-600 bg-opacity-75 z-50">
                        <div className="text-center text-white bg-gray-800 p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold">Your subscription has expired</h2>
                            <p className="mt-2">Please renew now to continue using the service.</p>
                            <button
                                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded transition duration-200 mt-4"
                                onClick={() => navigate('/subscribe')}
                            >
                                Renew Now
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default InnerLayout;
